// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"12dce2f3","453":"c06ab884","732":"d6b318ce","977":"663fc62c"}[chunkId] + ".chunk.js";
};